<ion-header>
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{ "@pages.profile.header" | translate }}
    </div>
  </div>
</ion-header>
<div class="padding-md wrap">
  <div [hidden]="(profile$ | async) === null">
    <app-tabs [model]="tabsModel" (tabClicked)="onSelectTab($event)"></app-tabs>

    <div [hidden]="tabsModel.activeTabIndex !== 0">
      <form class="form">
        <app-input
          [control]="profileForm.controls.name"
          [iconName]="'user'"
          [label]="'@pages.signup.form.fullname.label' | translate"
          [placeholder]="'@pages.signup.form.fullname.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [disabled]
        ></app-input>
        <app-input
          [control]="profileForm.controls.email"
          [iconName]="'email'"
          [label]="'@pages.signup.form.email.label' | translate"
          [placeholder]="'@pages.signup.form.email.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [inputType]="'email'"
        ></app-input>
        <app-input
          [control]="profileForm.controls.pickupHandle"
          [iconName]="'user'"
          [label]="'@pages.login.form.username.label' | translate"
          [placeholder]="'@pages.login.form.username.placeholder' | translate"
          [isMarkedAsRequired]="true"
        ></app-input>
        <app-input
          [control]="profileForm.controls.password"
          [iconName]="'lock'"
          [label]="'@pages.login.form.password.label' | translate"
          [placeholder]="'@pages.login.form.password.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [inputType]="'password'"
        ></app-input>
        <app-input
          [control]="profileForm.controls.confirmPassword"
          [iconName]="'lock'"
          [label]="'@pages.signup.form.confirmPassword.label' | translate"
          [placeholder]="
            '@pages.signup.form.confirmPassword.placeholder' | translate
          "
          [isMarkedAsRequired]="true"
          [inputType]="'password'"
        ></app-input>
        <app-dropdown
          [control]="profileForm.controls.locationHash"
          [iconName]="'store'"
          [label]="'@pages.signup.form.location.label' | translate"
          [placeholder]="'@pages.signup.form.location.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [model]="locationDropdownModel"
        ></app-dropdown>
        <app-action-button
          *ngIf="
            (clientCard$ | async) !== undefined &&
            (permissionService.has(permissions.CAN_USE_CREDIT_CARD) | async)
          "
          [isOutlined]="true"
          [label]="
            (clientCard$ | async) === false
              ? ('@pages.signup.form.addCard' | translate)
              : ('@pages.profile.form.editCard' | translate)
          "
          [endIconName]="'plus'"
          (click)="onEditCreditCardClick()"
          [disabled]="(loader.isLoading$ | async)!"
        ></app-action-button>
        <app-action-button
          [label]="'@pages.profile.form.actionBtn' | translate"
          [endIconName]="'plus'"
          (click)="onUpdateProfile()"
          [disabled]="profileForm.invalid"
          [isLoading]="(loader.isLoading$ | async)!"
        ></app-action-button>
      </form>
    </div>
  </div>

  <app-settings [hidden]="tabsModel.activeTabIndex !== 1"></app-settings>

  <div *ngIf="(profile$ | async) === null" class="loader">
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>
</div>
